import { pathnameSelector } from 'shared/app/state/selectors/routes';

import { SET_POST_STORE_SELECTION_RETURN_URL } from './types';

export const setPostStoreSelectionReturnUrl = () => (dispatch, getState) => {
  const pathname = pathnameSelector(getState());

  dispatch({
    type: SET_POST_STORE_SELECTION_RETURN_URL,
    payload: pathname,
  });
};
